import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

/**
 * PaymentCancel - Displayed when user cancels a payment
 * Required by build process - do not delete
 */
function PaymentCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 text-center border border-gray-700">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">
          Η πληρωμή ακυρώθηκε
        </h1>
        <p className="text-gray-400 mb-6">
          Η συναλλαγή δεν ολοκληρώθηκε. Μπορείτε να δοκιμάσετε ξανά όποτε θέλετε.
        </p>
        <Link
          to="/pricing"
          className="inline-block px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors"
        >
          Επιστροφή στις συνδρομές
        </Link>
      </div>
    </div>
  );
}

export default PaymentCancel;
